"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentsBlock = CommentsBlock;
exports.CommentsList = CommentsList;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _TitledBox = _interopRequireDefault(require("../TitledBox"));
var _FormattedMessage, _FormattedMessage2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    comment: {
      '& .hoverable': {
        visibility: 'hidden'
      },
      '&:hover .hoverable': {
        visibility: 'visible'
      }
    },
    commentAction: {
      color: theme.palette.text.primary,
      cursor: 'pointer',
      fontSize: '16px',
      marginLeft: theme.spacing(1)
    },
    commentActions: {
      marginLeft: 'auto'
    },
    commentEditActions: {
      display: 'flex',
      gap: theme.spacing(1),
      justifyContent: 'flex-end',
      paddingRight: '2px',
      paddingTop: theme.spacing(1),
      width: '100%'
    },
    commentLogo: {
      height: '18px',
      marginRight: theme.spacing(0.5),
      width: '18px'
    },
    commentText: {
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap'
    },
    commentTimestamp: {
      fontSize: 12
    },
    commentTitle: {
      '& p': {
        marginRight: theme.spacing(1)
      },
      alignItems: 'center',
      display: 'flex',
      marginBottom: theme.spacing(1)
    },
    divider: {
      height: 2,
      margin: theme.spacing(2, 0)
    }
  };
});
var EditableComment = function EditableComment(_ref) {
  var comment = _ref.comment,
    i = _ref.i,
    id = _ref.id;
  var classes = useStyles();
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var body = comment.comment,
    deletable = comment.deletable,
    editable = comment.editable,
    commentId = comment.id,
    Logo = comment.Logo,
    onDelete = comment.onDelete,
    onEdit = comment.onEdit;
  var parsedComment;
  if (comment.createdAt) {
    parsedComment = {
      author: {
        companyName: comment.companyName,
        displayName: comment.createdBy
      },
      body,
      createdAt: comment.createdAt
    };
  } else {
    var _comment$author;
    parsedComment = {
      author: {
        companyName: undefined,
        displayName: (_comment$author = comment.author) == null ? void 0 : _comment$author.displayName
      },
      body,
      createdAt: comment.created
    };
  }
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  (0, _react.useEffect)(function () {
    if (!editMode) {
      setValue(parsedComment.body);
    }
  }, [parsedComment.body, editMode, setValue]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.comment,
    id: "".concat(id).concat(i)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.commentTitle,
    id: "".concat(id).concat(i, "Title")
  }, !!Logo && /*#__PURE__*/_react.default.createElement(Logo, {
    className: classes.commentLogo
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1"
  }, /*#__PURE__*/_react.default.createElement("strong", {
    id: "".concat(id).concat(i, "Author")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "{displayName}{companyName, select, undefined {} other { from {companyName}}}",
    id: "comment.author",
    values: parsedComment.author
  }))), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.commentTimestamp,
    color: "textSecondary",
    id: "".concat(id).concat(i, "Time"),
    variant: "body1"
  }, new Date(parsedComment.createdAt).toLocaleString(undefined, {
    dateStyle: 'short',
    timeStyle: 'short'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.commentActions, {
      hoverable: !editMode
    })
  }, onDelete && deletable && /*#__PURE__*/_react.default.createElement(_iconsMaterial.Delete, {
    className: classes.commentAction,
    onClick: function onClick() {
      return onDelete(comment);
    }
  }), onEdit && editable && /*#__PURE__*/_react.default.createElement(_iconsMaterial.Create, {
    className: classes.commentAction,
    onClick: function onClick() {
      return setEditMode(!editMode);
    }
  }))), editMode ? /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    id: "".concat(id, "Comment"),
    label: formatMessage({
      defaultMessage: 'Edit comment',
      id: 'field.editComment'
    }),
    margin: "dense",
    multiline: true,
    name: "comment",
    onChange: function onChange(event) {
      return setValue(event.target.value);
    },
    value: value,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.commentEditActions
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    id: "".concat(id, "SubmitButton"),
    onClick: function onClick() {
      return setEditMode(false);
    },
    size: "small"
  }, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "actions.cancel"
  }))), /*#__PURE__*/_react.default.createElement(_material.Button, {
    color: "primary",
    disabled: submitting || !value,
    id: "".concat(id, "SubmitButton"),
    onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSubmitting(true);
            Promise.resolve(onEdit({
              comment: value,
              id: commentId
            })).then(function () {
              setSubmitting(false);
              setEditMode(false);
            }).finally(function () {
              setSubmitting(false);
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    size: "small",
    variant: "contained"
  }, _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "actions.save"
  }))))) : /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.commentText,
    id: "".concat(id).concat(i, "Body"),
    variant: "body1"
  }, parsedComment.body));
};
function CommentsList(_ref3) {
  var _ref3$comments = _ref3.comments,
    comments = _ref3$comments === void 0 ? [] : _ref3$comments,
    _ref3$dividerAfter = _ref3.dividerAfter,
    dividerAfter = _ref3$dividerAfter === void 0 ? true : _ref3$dividerAfter,
    _ref3$dividerBefore = _ref3.dividerBefore,
    dividerBefore = _ref3$dividerBefore === void 0 ? false : _ref3$dividerBefore,
    id = _ref3.id;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dividerBefore && comments.length > 0 && /*#__PURE__*/_react.default.createElement(_material.Divider, {
    className: classes.divider
  }), comments.map(function (comment, i) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: comment.id
    }, /*#__PURE__*/_react.default.createElement(EditableComment, {
      classes: classes,
      comment: comment,
      i: i,
      id: id
    }), i < comments.length - 1 && /*#__PURE__*/_react.default.createElement(_material.Divider, {
      className: classes.divider
    }));
  }), dividerAfter && comments.length > 0 && /*#__PURE__*/_react.default.createElement(_material.Divider, {
    className: classes.divider
  }));
}
function CommentsBlock(_ref4) {
  var _ref4$comments = _ref4.comments,
    comments = _ref4$comments === void 0 ? [] : _ref4$comments,
    children = _ref4.children,
    dividerAfter = _ref4.dividerAfter,
    dividerBefore = _ref4.dividerBefore,
    id = _ref4.id,
    titleKey = _ref4.titleKey;
  return /*#__PURE__*/_react.default.createElement(_TitledBox.default, {
    id: id,
    mt: 2,
    titleKey: titleKey
  }, /*#__PURE__*/_react.default.createElement(CommentsList, {
    comments: comments,
    dividerAfter: dividerAfter,
    dividerBefore: dividerBefore,
    id: id
  }), children);
}